import validate from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7_supports-color@1_442477e22c1d0e45cc8f50a790870a47/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/middleware/auth.global.ts";
import handle_45localization_45global from "/var/www/middleware/handle-localization.global.ts";
import manifest_45route_45rule from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7_supports-color@1_442477e22c1d0e45cc8f50a790870a47/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  handle_45localization_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}